import { render, staticRenderFns } from "./MenuBarItems.vue?vue&type=template&id=a9dc793c&scoped=true"
import script from "./MenuBarItems.vue?vue&type=script&lang=js"
export * from "./MenuBarItems.vue?vue&type=script&lang=js"
import style0 from "./MenuBarItems.vue?vue&type=style&index=0&id=a9dc793c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9dc793c",
  null
  
)

export default component.exports